import { Reducer } from 'redux';
import MapLocationSearchActionTypes from './types';
import { MapLocationSearchState } from './types';

export const initialState: MapLocationSearchState = {
  suggestion: [],
  suggestionError: ''
};

const reducer: Reducer<MapLocationSearchState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case MapLocationSearchActionTypes.GET_ADDRESS_SUGGESTION_SUCCESS:
      return {
        ...state,
        suggestion: action.payload
      };
    case MapLocationSearchActionTypes.GET_ADDRESS_SUGGESTION_FAILURE:
      return {
        ...state,
        suggestion: [],
        suggestionError: action.payload
      };
    case MapLocationSearchActionTypes.CLEAR_ADDRESS_SUGGESTION:
      return {
        ...state,
        suggestion: [],
        suggestionError: ''
      };
    case MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_START:
      return {
        ...state,
        addressCandidate: undefined
      };
    case MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_SUCCESS:
      return {
        ...state,
        addressCandidate: action.payload
      };
    case MapLocationSearchActionTypes.GET_ADDRESS_CANDIDATE_FAILURE:
      return {
        ...state,
        addressCandidate: undefined,
        addressCandidateError: action.payload
      };
    case MapLocationSearchActionTypes.CLEAR_ADDRESS_CANDIDATE:
      return {
        ...state,
        addressCandidate: undefined,
        addressCandidateError: ''
      };
    case MapLocationSearchActionTypes.GET_LOT_NUM_SUGGESTION_SUCCESS:
      return {
        ...state,
        suggestion: action.payload
      };
    case MapLocationSearchActionTypes.GET_LOT_NUM_SUGGESTION_FAILURE:
      return {
        ...state,
        suggestion: [],
        suggestionError: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
